import { ISubject } from '@/types/services';

export const AdditionalDocumentsType = {
  ADD_QUITTANCES: 'ADD_QUITTANCES',
  ADD_DOCUMENTS: 'ADD_DOCUMENTS',
  RESEND_TO_FSSP: 'RESEND_TO_FSSP',
};

export interface IRequestRefusalSend {
  addStatementId: string;
  xmlSigBase64: string;
}

export interface IAltDistrict {
  id: string;
  applicant: ISubject;
  xml: string;
  originalStatementId: string;
  originalStatementType: string;
  originalStatementExtId: string;
  addStatementType: string;
  xmlLink: string;
}

export interface IRequestParamDistrict {
  statementId: string;
  regionCode: string;
  districtId: string;
  chamberId: string;
}
